export default __webpack_public_path__ + "static/media/KikVagyunk.21c627be.jpg";